import React from 'react'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
// import posed, { PoseGroup } from "react-pose";
import { Container } from 'reactstrap'
import Navbar from './Navbar'
import Footer from './Footer'
import 'typeface-noto-sans'
import 'typeface-kalam'
import theme from '../styles/theme'
import '../styles/main.scss'
import SEO from './SEO'

// scale: 12, 14, 16, 18, 20, 24, 30, 36, 48, 60
const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    border-top: solid 8px ${theme.colors.main};
    /* border-top: solid 8px ${theme.colors.secondary}; */
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  body {
    padding: 0;
    margin: 0;
    line-height: 1.5;
    font-family: 'Noto Sans';
  }
  a {
    font-family: 'Noto Sans';
    text-decoration: none;
    color: ${theme.colors.main} !important;
  }
  button {
    font-family: 'Noto Sans';
  }
  h1,h2,h3,h4,h5,h5 {
    font-family: 'Kalam';
    color: ${theme.colors.main};
  }
  #isis{
    /* background-color: ${theme.colors.secondary}; */
    h1 {
    font-size: 30px;
  }

  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 20px;
  }

  h4 {
    font-size: 18px;
  }


    @media (max-width: ${theme.breakpoints.md}) {
    h1 {
      font-size: 24px;
    }

    h2 {
      font-size: 20px;
    }

    h3 {
      font-size: 18px;
    }

    h4 {
      font-size: 16px;
    }
  }

  h1,
  h2,
  h3 {
    font-weight: 700;
  }

  h4,
  h5,
  h6 {
    font-weight: 600;
  }
  }

`

const Layout = ({ children, ...props }) => (
  <>
    <GlobalStyle />
    <ThemeProvider theme={theme}>
      <div id="isis" style={{ minHeight: '80vh' }}>
        <Navbar {...props} />
        {children}
        <Footer />
      </div>
    </ThemeProvider>
  </>
)

export default Layout
